import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { App as AntApp, Button, Form, Input } from "antd";

import { useAuth } from "../auth";
import { ApiError } from "../api";

export function LoginPage() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { message } = AntApp.useApp();
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) {
    const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname ?? "/";
    return <Navigate to={from} replace />;
  }

  async function handleFinish(values: { email: string; password: string }) {
    setSubmitting(true);
    try {
      await login(values.email, values.password);
      navigate("/scrapers", { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) message.error("Invalid email or password.");
      else message.error(err instanceof Error ? err.message : "Login failed");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="crl-login-shell">
      <div className="crl-login-card">
        <div className="crl-login-logo">C</div>
        <h2>Welcome back</h2>
        <div className="crl-sub">Sign in to your Crawly workspace</div>
        <Form layout="vertical" onFinish={handleFinish} requiredMark={false}>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Email required" },
              { type: "email", message: "Must be a valid email" },
            ]}
          >
            <Input autoFocus />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Password required" }]}
          >
            <Input.Password />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={submitting}>
            Sign in
          </Button>
        </Form>
      </div>
    </div>
  );
}
